import React from "react";
import {
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  AreaChart,
} from "recharts";
import { getYAxisDataForAreaChart } from "components/Dashboards/AdministrativeDashboard/utils";
import "./styles.scss";
import CustomDot from "./CustomDot";
import CustomTooltip from "./CustomTooltip";

type Props = {
  data: { name: string; amount: number; percentage: number }[];
  period: string;
};

const CustomAreaChart = ({ data, period }: Props) => {
  const isWeekPeriod = period === "weekly";
  const { yAxisTicks, maxY } = getYAxisDataForAreaChart(period);
  const tickFillColor = "#293172";

  return (
    // D-10: charts keep their natural (LTR) orientation in both languages.
    <div dir="ltr" style={{ display: "inline-block" }}>
      <AreaChart
        width={560}
        height={215}
        data={data}
        margin={{
          top: 10,
          right: 20,
          left: 0,
          bottom: 15,
        }}
      >
        <defs>
          <linearGradient id="areaColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#e6e8ef" stopOpacity={0.8} />
            <stop offset="35%" stopColor="#e6e8ef" stopOpacity={0.6} />
            <stop offset="95%" stopColor="#e6e8ef" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="lineColor">
            <stop offset="0%" stopColor="rgba(4,11,68,1)" />
            <stop offset="25%" stopColor="rgba(4,11,68,1)" />
            <stop offset="50%" stopColor="rgba(40,124,137,1)" />
            <stop offset="70%" stopColor="rgba(50,157,157,1)" />
            <stop offset="85%" stopColor="rgba(63,202,184,1)" />
            <stop offset="100%" stopColor="rgba(80,254,216,1)" />
          </linearGradient>
        </defs>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={false}
          angle={isWeekPeriod ? -40 : 0}
          padding={{ left: 5, right: 5 }}
          tickMargin={15}
          interval={0}
          tick={{ fill: tickFillColor }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickMargin={50}
          domain={[0, maxY]}
          ticks={yAxisTicks}
          interval={0}
          tick={{ fill: tickFillColor }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="natural"
          dataKey="amount"
          stroke="url(#lineColor)"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#areaColor)"
          dot={<CustomDot data={data} isActive={false} />}
          activeDot={<CustomDot data={data} isActive />}
        />
      </AreaChart>
    </div>
  );
};

export default CustomAreaChart;
